// 单课首页 V2  非直播
export const newSingleCourseV2Router = {
  path: '/newsingle/course/v2',
  name: 'newsinglecoursev2',
  meta: {
    title: '新东方专题活动'
  },
  component: () => import('@/page/b0newmarketing/singlecourseV2')
}

// 套餐首页 V2  非直播
export const newPackageV2Router = {
  path: '/newpackage/v2',
  name: 'newpackagev2',
  meta: {
    title: '新东方专题活动'
  },
  component: () => import('@/page/b0newmarketing/packageV2')
}


// // 落地页测评结果页面
// export const appraisalResult = {
//   path: '/appraisalResult',
//   name: 'appraisalResult',
//   meta: {
//     title: '测评结果'
//   },
//   component: () => import('@/page/publicityPage/appraisalResult')
// }
// export const page404 = {
//   path: '*',
//   name: 'error_404',
//   meta: {
//     title: '404-页面不存在'
//   },
//   component: error_404
// }

// 作为Work组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
// export const appRouter = [
//   {
//     path: '/lessons',
//     name: 'lessons',
//     component: () => import(''),
//     children: [
//       {
//         path: 'course',
//         name: 'course',
//         meta: {
//           keepAlive: true
//         },
//         component: () => import('@/view/course/course')
//       }
//     ]
//   }
// ]
// 所有上面定义的路由都要写在下面的routers里
export const routes = [
  newPackageV2Router,
  newSingleCourseV2Router
]
